import { Lightning } from '@lightningjs/sdk'

import { getColor, grey50, grey920, grey960 } from '../../constants/colors'
import { getIcon } from '../../utils/image'
import SpeechComp from '../speechComp/speechComp'
import { SpecialKey } from './CustomKeyboard'
import { ICON_SIZE, KEY_HEIGHT, SPECIAL_KEY_ROW_COLS, SPECIAL_KEY_WIDTH } from './keyboardUtils'

export default class KeySpecial extends SpeechComp {
  private _rowIndex = 0
  private _index = 0
  private _keyValue: SpecialKey

  static _template() {
    return {
      w: SPECIAL_KEY_WIDTH,
      h: KEY_HEIGHT,
      rect: true,
      color: getColor(grey920),
      collision: true,
      flex: {
        justifyContent: 'center',
        alignItems: 'center',
      },
      Icon: {
        color: getColor(grey50),
        texture: null,
        shader: null,
      },
    }
  }

  get speechText(): string {
    return this._keyValue.speechText
  }

  get icon() {
    return this.tag('Icon')
  }

  set index(v: number) {
    this._index = v
  }

  get index() {
    return this._index
  }

  set rowIndex(v: number) {
    this._rowIndex = v
  }

  get rowIndex() {
    return this._rowIndex
  }

  get value() {
    return this._keyValue
  }

  set key(v: SpecialKey) {
    this._keyValue = v

    this.patch({
      shader: {
        type: Lightning.shaders.RoundedRectangle,
        radius: this.getKeyRadius(this._index),
      },
    })

    this.icon.patch({
      texture: Lightning.Tools.getSvgTexture(getIcon(v.route), ICON_SIZE, ICON_SIZE),
    })
  }

  _focus() {
    this.patch({
      color: getColor(grey50),
      Icon: {
        color: getColor(grey960),
      },
    })
    this.speak()
  }

  _unfocus() {
    this.patch({
      color: getColor(grey920),
      Icon: {
        color: getColor(grey50),
      },
    })
  }

  getKeyRadius(keyIndex) {
    if (keyIndex === 0) {
      // First key, bottom left corner
      return [0, 0, 0, 16]
    }

    if (keyIndex === SPECIAL_KEY_ROW_COLS - 1) {
      // Last key, bottom right corner
      return [0, 0, 16, 0]
    }

    return 0
  }

  _handleHover() {
    this.fireAncestors('$updateFocusByHover', this)
    this._focus()
  }

  _handleUnhover() {
    this._unfocus()
  }

  _handleKey() {
    return false
  }
}
